// Centralised site content + media

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES_DROPDOWN = [
  { label: "Drainage", to: "/drainage" },
  { label: "Groundworks", to: "/groundworks" },
  { label: "Residential Landscaping", to: "/residential-landscaping" },
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/rt28tayr_WhatsApp%20Image%202026-03-05%20at%2020.45.00.jpeg";
export const WHY_IMAGE = "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/7piqucxo_WhatsApp%20Image%202026-03-26%20at%2021.15.07.jpeg";
export const ABOUT_HERO_IMAGE = "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/h1515h8g_WhatsApp%20Image%202026-03-05%20at%2021.04.23.jpeg";
export const CONTACT_HERO_IMAGE = "https://images.unsplash.com/photo-1715738547210-4aad4af24938";
export const TESTI_HERO_IMAGE = "https://images.pexels.com/photos/7174105/pexels-photo-7174105.jpeg";
export const ABOUT_STORY_IMAGE = "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/rokug1y3_WhatsApp%20Image%202026-03-05%20at%2021.05.59.jpeg";

// User-uploaded gallery composites
export const MOCKUPS = {
  drainage: "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/ha1nkof0_6F41A04F-C078-4501-AFA3-60FB969AA2AF.PNG",
  groundworks: "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/l2hy1hfq_38238C1B-4DE5-4F38-B1C3-0B985C4CDD32.PNG",
  landscaping: "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/aac1lp7x_8E679788-B4B6-4681-BF83-E895887C621B.PNG",
};

export const GALLERIES = {
  drainage: [
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/ry22e5dt_82d5f9a2-5374-48a2-a8b5-6702304c9643.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/5ppum4jo_9513d7a8-99f1-4313-85e6-f265e05650e1.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/xo4gshm8_75d89db4-b0de-4dfa-8f64-23dd04def04c.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/ntu5638p_92ef8635-5626-4902-b371-8a10c66261ca.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/doib9qow_75a1c421-5f4f-4dfc-a0ab-1290bb90b94f.jpg",
  ],
  groundworks: [
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/r14ue931_6d3f4ac3-5cc2-4e62-8e09-1fa30b7babcd.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/b93ygb0t_4cfe7947-aee5-44e2-bf83-ae08de7a6f07.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/ge13zoak_7b21366b-425d-4e78-b94b-0521e119569a.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/6jopyaar_b639380b-1f18-4e36-8930-b5884dc666cd.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/q6k2qjwt_3bca322e-0241-4b18-921f-1d7181dfa1b7.JPG",
  ],
  landscaping: [
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/ypsbfuu4_07f6a628-b6db-46ad-b894-de4232987dca.JPG",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/s9fn5bwt_d707a477-8762-42cd-948b-e1a5a8ea8f6b%20%281%29.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/pwngkz3g_db5d47f7-4e1e-49a7-8fad-8dcfe0ca32e2%20%281%29.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/rytppjh8_730a679d-b42f-4d52-a14b-34fddd14032f%20%281%29.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/h1yq32xa_Screenshot%202026-02-25%20145939.png",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/rtieh1rg_Screenshot%202026-02-25%20132706.png",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/qzna5j27_IMG_4692.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/1f76cbx4_IMG_4693.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/yguymogf_IMG_4694.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/iu454l8e_IMG_4702.jpg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/ufb6wdo5_WhatsApp%20Image%202026-03-05%20at%2020.56.01.jpeg",
    "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/1u32f1cg_WhatsApp%20Image%202026-03-05%20at%2021.05.59.jpeg",
  ],
};

export const TESTIMONIAL_FACES = [
  "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/7zmeu1x9_City%20Civils%20-%20Icon.png",
  "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/7zmeu1x9_City%20Civils%20-%20Icon.png",
  "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/7zmeu1x9_City%20Civils%20-%20Icon.png",
  "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/7zmeu1x9_City%20Civils%20-%20Icon.png",
];

export const TESTIMONIALS = [
  {
    name: "Scott Barclay",
    location: "Edinburgh, UK",
    image: TESTIMONIAL_FACES[0],
    text: "Had some damage from recent storms on my fences. City Civils were out the same week and all fixed. Where fixing wasn't an option they completely replaced one side. Great quality work.",
  },
  {
    name: "Kai Stewart",
    location: "Edinburgh, UK",
    image: TESTIMONIAL_FACES[1],
    text: "These guys came and helped me out with my garden in the spring and I've enjoyed a great summer in my garden - can't thank them enough.",
  },
  {
    name: "James Mitchell",
    location: "Edinburgh, UK",
    image: TESTIMONIAL_FACES[2],
    text: "City Civils came and installed a new driveway and fenced off all around the property. All done quickly and efficiently. Highly recommended.",
  },
  {
    name: "Lorna McCall",
    location: "Musselburgh, UK",
    image: TESTIMONIAL_FACES[3],
    text: "These guys came and helped me out with my garden in the spring and I've enjoyed a great summer in my garden can't thank them enough and I'd definitely recommend them.",
  },
  {
    name: "Jamie Thomson",
    location: "Google Review",
    image: TESTIMONIAL_FACES[0],
    text: "City Civils was recommended to me by a friend he had previous had work done by them and praised how good a job they had done. Guys where great explained everything in detail and the process of how the job would go, our garden used to pool at low points Frazer and his team done an amazing job levelling out the garden and putting in a drainage system. I am happy to say since then had no more issues and can't recommend them enough.",
  },
  {
    name: "Brian Wright",
    location: "Google Review",
    image: TESTIMONIAL_FACES[1],
    text: "I recently hired City Civils Construction & Landscaping to lay setts and install lighting channels to finish off a large patio area, and I'm really pleased with the results. The team arrived on time and kept the site tidy throughout the project. As can be seen from the pictures setts and the lighting looking great. What stood out most was how friendly and helpful Scott and the team were. They were always happy to answer questions, discuss options, and make small adjustments to get it just right. No fuss, great communication, and genuinely nice guys to have around. Would highly recommend them for any landscaping or civils work — top-notch service from start to finish!",
  },
  {
    name: "Jaynie Hedley",
    location: "Google Review",
    image: TESTIMONIAL_FACES[2],
    text: "We recently moved into a new build home, and our garden was on quite a slope, so we needed some help to make it more usable. After getting in touch with City Civils for a quote, we decided to go ahead with them to level the garden, create a patio area with porcelain slabs, and lay some spare slabs we already had. From start to finish, they were professional, efficient, and easy to deal with. Communication was excellent throughout the whole process — they kept us informed at every stage and made sure we were happy with everything as the work progressed. The transformation is amazing. They've turned our sloped garden into beautifully finished tiers, creating a space that's not only practical but also looks fantastic. The patio area is exactly what we hoped for, and the attention to detail really shows. We honestly couldn't be happier with the result. I can't wait to enjoy the summer in our new garden with my kids, all thanks to the great work from City Civils. Highly recommend!",
  },
  {
    name: "Michael Gray",
    location: "Google Review",
    image: TESTIMONIAL_FACES[3],
    text: "Used City Civils to investigate and repair a drainage issue that had been causing problems for months. Scott and Jordan were great from the start. They took the time to explain what they found, talked us through the repair options, and were honest and professional throughout. The work was carried out efficiently, the site was left clean and tidy, and everything was completed when they said it would be. Really pleased with the outcome and wouldn't hesitate to recommend Scott, Jordan, and the team at City Civils.",
  },
  {
    name: "Karen Clyde",
    location: "Google Review",
    image: TESTIMONIAL_FACES[0],
    text: "We are extremely happy with our patio and planters completed by City Civils. From start to finish, the team was professional, reliable, and kept us informed with clear communication. The quality of the work is excellent. Will definitely use them again for our landscaping projects in the future — really recommend.",
  },
];

export const SERVICES = [
  {
    title: "Drainage",
    description: "Surface water, soakaways and full drainage systems engineered properly.",
    to: "/drainage",
    icon: "Droplets",
  },
  {
    title: "Groundworks",
    description: "Site preparation, excavation, and foundations built for the long haul.",
    to: "/groundworks",
    icon: "Layers",
  },
  {
    title: "Residential Landscaping",
    description: "Driveways, patios, decking, fencing, artificial grass and full garden makeovers.",
    to: "/residential-landscaping",
    icon: "Sprout",
  },
];

export const COMPANY = {
  name: "City Civils Construction Ltd",
  phone: "+44 0131 214 1900",
  phoneShort: "0131 214 1900",
  email: "info@citycivilsconstruction.co.uk",
  addressLine: "172 Baberton Mains Dr, Edinburgh, EH14 3DZ, United Kingdom",
  city: "Edinburgh, Scotland",
  instagram: "https://www.instagram.com/city_civils/",
  facebook: "https://www.facebook.com/people/City-Civils-Construction-Landscaping/61572655254062/",
};
